export default "__VITE_ASSET__e4de94c6__"